export const menuItems = [
    // {
    //     id: 1,
    //     label: "",
    //     isTitle: true
    // },
    {
        id: 2,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: '/'
    },    
    {
        id: 3,
        label: "menuitems.documents.text",
        icon: "bx-archive",
        link: '/documents',
    },
    {
        id: 10,
        label: "menuitems.tasks.text",
        icon: "bx-file",
        link: '/tasks',
        subject: 'tasks',
        subItems: [
            {
                id: 14,
                label: "menuitems.tasks.waiting.text",
                icon: "bx-data",
                link: "/tasks/pending",
                parentId: 10
            },
            {
                id: 15,
                label: "menuitems.tasks.approved.text",
                icon: "bx-data",
                link: "/tasks/completed",
                parentId: 10
            },
            {
                id: 16,
                label: "menuitems.tasks.rejected.text",
                icon: "bx-data",
                link: "/tasks/sent",
                parentId: 10
            },
        ]
    },
    {
        id: 4,
        label: "menuitems.users.text",
        icon: "bx-user",
        authorizedUsers: ['admin'],
        subject: 'users',
        link: "/users",
        // subItems: [{
        //         id: 1,
        //         label: "menuitems.users.items.create",
        //         link: "/users/create",
        //         type: "create",
        //         parentId: 5
        //     },
        //     {
        //         id: 2,
        //         label: "menuitems.users.items.list",
        //         link: "/users",
        //         type: 'list',
        //         parentId: 5
        //     }
        // ]
    },
    {
        id: 7,
        label: "menuitems.activity.text",
        icon: "bx-list-ul",
        authorizedUsers: ['admin'],
        link: "/logs",
        subject: 'logs'

    },
    {
        id: 9,
        label: "menuitems.Settings.text",
        icon: "bx bx-wrench",
        authorizedUsers: ['admin'],
        subject: 'settings',
        subItems: [
            {
                id: 7,
                label: "menuitems.documenttype.text",
                icon: "bx-data",
                link: "/document-types",
                subject: 'document-types',
                parentId: 9
            },
            {
                id: 6,
                label: "menuitems.groups.text",
                icon: "bx-data",
                link: "/groups",
                subject: 'actions',
                parentId: 9
            },  
            {
                id: 2,
                label: "pages.roles.list",
                link: "/roles",
                subject: 'roles',
                parentId: 9

            },
            {
                id: 3,
                label: "menuitems.metadata.text",
                icon: "bx-data",
                link: "/metadata",
                subject: 'metadata',
                parentId: 9
            },
            {
                id: 4,
                label: "menuitems.workflow.text",
                icon: "bx-data",
                link: "/workflows",
                subject: 'processes',
                parentId: 9
            },
            {
                id: 5,
                label: "menuitems.actions.text",
                icon: "bx-data",
                link: "/actions",
                subject: 'actions',
                parentId: 9
            }
        ]
    },
];